import { apiClient } from "../api/apiclient";

export const getAllClients = (token) =>
  apiClient.get(`/Iclients`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  
export const getAllInstitutes = (token) =>
  apiClient.get(`/Iclients`, {
    headers: { Authorization: `Bearer ${token}` },
  });